import { Box } from '@mui/material';
import { memo } from 'react';

import type { TimelineWindow } from './timelineModel';

import { MicroLabel } from '@/components/ui';

export type TimelineHeaderProps = {
  window: TimelineWindow;
  /** Current zoom, px per day. */
  dayWidth: number;
};

/**
 * The month band. Memoized on the window object, which `unionWindows` keeps
 * referentially stable across drags — so dragging a bar never re-renders this;
 * only a zoom change (new `dayWidth`) does.
 */
export const TimelineHeader = memo(({ window, dayWidth }: TimelineHeaderProps) => (
  <Box sx={{ display: 'flex', flex: 'none' }}>
    {window.months.map((month) => (
      <Box
        key={month.key}
        data-automation-id="timeline-month"
        sx={{
          width: `${String(month.dayCount * dayWidth)}px`,
          flex: 'none',
          py: 1,
          pl: 1,
          borderLeft: '1px solid var(--border-divider)',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        }}
      >
        <MicroLabel color="var(--fg-2)">{month.label}</MicroLabel>
      </Box>
    ))}
  </Box>
));

TimelineHeader.displayName = 'TimelineHeader';
